import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { LocationDisplay } from "~/components/ui/location-display-eon";
import type { Job } from "~/types/job";
export function PrintviewHeader(t0) {
  const $ = _c(18);
  const {
    job
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CustomImage alt="" className="absolute top-0 left-0 z-0 h-full w-full object-cover" height={215} loading="eager" src="images/jobad/print-header.png" width={888} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fontFamily: "var(--font-eon-headline), sans-serif"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== job.data.title) {
    t3 = <h1 className="mb-2 text-start font-medium text-3xl" style={t2}>{job.data.title}</h1>;
    $[2] = job.data.title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== job.data.company) {
    t4 = <p className="font-normal text-xl">{job.data.company}</p>;
    $[4] = job.data.company;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== job) {
    t5 = <div className="[&_*]:!font-normal text-left text-base"><LocationDisplay job={job} showAll={true} /></div>;
    $[6] = job;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <div className="z-10 col-span-7 flex flex-col items-start gap-1 px-8 pt-8 pb-2 text-lg text-white">{t3}{t4}{t5}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="relative col-span-1"><CustomImage alt="E.ON Logo" className="absolute right-8 bottom-2 w-full" height={215} loading="eager" src="images/logo/logo-white.svg" width={888} /></div>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6) {
    t8 = <div className="relative grid h-[5.5cm] w-full grid-flow-col grid-cols-8">{t1}{t6}{t7}</div>;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="row-span-full flex h-[0.5cm] w-full" />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8) {
    t10 = <tbody><tr><td>{t8}{t9}</td></tr></tbody>;
    $[16] = t8;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}